import React from 'react';
import DonorSolidIcon from './DonorSolidIcon';
import EchoSolidIcon from './EchoSolidIcon';
import ServiceIcon from './ServiceIcon';

function DeviceIcon({ type, ...rest }) {
  switch (type) {
    case 'donor':
      return <DonorSolidIcon color="orange" {...rest} />;
    case 'service':
      return <ServiceIcon color="orange" {...rest} />;
    case 'subscriber':
      return <EchoSolidIcon {...rest} />;
    default:
      return null;
  }
}

export default DeviceIcon;
